import { useEffect, useState } from "react";
import { getRoles } from "../../services/silentAuth";

function useHasRole(role: string): boolean {
   const roles = getRoles();

   const [hasRole, setHasRole] = useState(false);

   useEffect(() => {
    if ( !roles )
        setHasRole(false);

    setHasRole(roles?.find(v => v === role) !== undefined);
  }, [roles])

   return hasRole;
}

export default useHasRole